let bodyPosition = 0;

// REQUIRES VARIABLE (isIos) TO BE SET IN FOOTER USING Mobile_Detect.php:
// var isIos = <?php echo  $mobile_detect->isiOS() ? 'true' : 'false' ?>;

var freezeVp = function(e) {
  e.preventDefault();
};

export const freezeBody = () => {
  if(isIos){
    // document.body.addEventListener("touchmove", freezeVp, false);
    const doc = document.documentElement;
    bodyPosition = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.left = '0';
    document.body.style.top = Math.abs(bodyPosition) * -1 + 'px';
    document.body.style.right = '0';
  }
};

export const unfreezeBody = () => {
  if(isIos){
    // document.body.removeEventListener("touchmove", freezeVp, false);
    document.body.style.overflow = 'auto';
    document.body.style.position = 'static';
    document.body.removeAttribute('style');
    window.scrollTo(0, bodyPosition);
    bodyPosition = 0;
  }
};
